import React from 'react';

type Variant = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

interface Props {
  variant?: Variant;
  children: React.ReactNode;
}

const PALETTE: Record<Variant, { bg: string; fg: string }> = {
  success: { bg: 'var(--green-100)', fg: 'var(--green-800)' },
  warning: { bg: 'var(--yellow-100)', fg: 'var(--yellow-900)' },
  danger: { bg: 'var(--red-100)', fg: 'var(--red-900)' },
  info: { bg: 'var(--blue-100)', fg: 'var(--blue-900)' },
  neutral: { bg: 'var(--neutral-200)', fg: 'var(--neutral-700)' },
};

export const Badge: React.FC<Props> = ({ variant = 'neutral', children }) => {
  const p = PALETTE[variant];
  return (
    <span
      style={{
        display: 'inline-block',
        background: p.bg,
        color: p.fg,
        fontSize: 12,
        fontWeight: 600,
        padding: '4px 8px',
        borderRadius: 'var(--radius-sm)',
        letterSpacing: 0.2,
        textTransform: 'uppercase',
      }}
    >
      {children}
    </span>
  );
};
